import { Link } from "react-router-dom";
import styles from "./style.module.scss";
import Logo from "src/assets/logo_color.png";

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className={styles.container}>
      <div className={styles.scrollTop} onClick={scrollToTop}>
        △トップへ戻る
      </div>
      <ul>
        <li>
          <p className={styles.link}>
            <Link to="/" className={styles.link}>
              →HOME
            </Link>
          </p>

          <p className={styles.link}>
            <Link to="/facility-overview" className={styles.link}>
              →基本情報
            </Link>
          </p>
        </li>
        <li>
          <p className={styles.link}>
            <Link to="/activity" className={styles.link}>
              →体験一覧
            </Link>
          </p>
          <p className={styles.link}>
            <Link to="/access">→アクセス</Link>
          </p>
        </li>
        <li>
          <p className={styles.link}>
            <Link to="/faq" className={styles.link}>
              →FAQ
            </Link>
          </p>
          <p className={styles.link}>
            <Link to="/accomodation-contract" className={styles.link}>
              →宿泊約款
            </Link>
          </p>
        </li>
        <li>
          <p className={styles.link}>
            <Link to="/personal-policy">→個人情報保護方針</Link>
          </p>
          <p className={styles.link}>
            <a href="https://forms.gle/dzrBZ2RM3toyT3XD7" target="_blank">
              →お問い合わせ
            </a>
          </p>
        </li>
      </ul>
      <div className={styles.logoBox}>
        <Link to="/">
          <img src={Logo} alt="Logo" />
        </Link>
      </div>
      <div className={styles.companyNameBox}>
        <a
          href="https://aihome.biz/"
          target="_blank"
          rel="noreferrer"
          className={styles.companyName}
        >
          運営会社 : 株式会社あいホーム
        </a>
      </div>

      <p className={styles.copyRight}>
        COPYRIGHT © 2025 ISHINOMAKI MARIN VILLAGE
      </p>
    </footer>
  );
};
